import { useEffect, useSyncExternalStore } from 'react';
import { getFeatureFlagValue, loadFeatureFlag, subscribeFeatureFlags } from '../configuration/featureFlagStore';
import type { FeatureFlagName } from '../configuration/featureFlags';

export function useFeatureFlag(flag: FeatureFlagName): boolean {
    useEffect(() => {
        loadFeatureFlag(flag);
    }, [flag]);

    return useSyncExternalStore(subscribeFeatureFlags, () => getFeatureFlagValue(flag));
}
